module.exports = __webpack_public_path__ + "img/g-play-old.602f6550.png";